// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__1KYWk","text":"text__2_ECx","showAnswer":"showAnswer__3xbpB"};


//////////////////
// WEBPACK FOOTER
// ./components/ChatBot/styles/response.scss
// module id = xyaq
// module chunks = 0